import React from 'react';

import Thumbnail from 'components/Thumbnail';

import { FilePropType } from 'propTypes/common';

import styles from '../styles.module.scss';

const Image = ({ file }) => (
	<div
		className={styles.item}
		style={{ width: `${(23 * file.width) / file.height}em` }}
	>
		<Thumbnail
			file={file}
			className={styles.image}
			params={{
				height: 364
			}}
		/>
	</div>
);

Image.propTypes = {
	file: FilePropType.isRequired
};

export default Image;
